export default function () {
  const setScrollbarWidth = () => {
    document.documentElement.style.setProperty(
      "--scrollbar-width",
      `${window.innerWidth - document.documentElement.clientWidth}px`
    );
  };
  window.addEventListener("resize", setScrollbarWidth);
  setScrollbarWidth();
}